// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import NavBar from "../../../components/ui/NavBar";
import { MdLocationPin, MdOutlineSearch } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import Footer from "../../../components/ui/Footer";
import PaymentPartners from "../../../components/ui/PaymentPartners";
import HowToReachUs from "../../../components/ui/HowToReachUs";
import { useDispatch, useSelector } from "react-redux";
import { fetchBookingByReference } from "../../../redux/slices/userSlice";
import { ImSpinner2 } from "react-icons/im";
import moment from "moment";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

// Images
import emptyImage from "../../../assets/images/empty.png";
import BookingDetails from "../../../components/ui/BookingDetails";

function TrackBookingPage() {
  const howItWorksRef = useRef(null);
  const moreAboutUsRef = useRef(null);

  // Get bookingRef from URL
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const bookingRef = searchParams.get("bookingRef");

  // Search states
  const [searchValue, setSearchValue] = useState(bookingRef);

  const { isLoading, bookingFetchedByReference } = useSelector(
    (store) => store.user
  );
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("BOOKING REFERENCE:", bookingRef);
    if (bookingRef) {
      setSearchValue(bookingRef);
      dispatch(fetchBookingByReference(bookingRef));
    }
  }, [bookingRef]);

  async function getBookingByBookingReference(value) {
    console.log("SEARCH VALUE:", value);
    if (!value || value?.trim() !== "") {
      dispatch(fetchBookingByReference(searchValue?.trim() ?? value?.trim()));
    } else {
      toast.info("You must provide a valid booking reference!");
    }
  }

  return (
    <div className="relative bg-white">
      <Helmet>
        <title>Track Booking | Shuttlelane</title>
      </Helmet>

      <ToastContainer />
      <div className="fixed w-full z-20">
        <NavBar isPurpleLogo={true} />
      </div>

      {/* Track Booking */}
      <div
        className="px-8 relative bg-white lg:px-24 py-24 pt-44 h-[30vh] flex items-center justify-center"
        ref={howItWorksRef}
      >
        <div className="flex relative z-10 lg:flex-row flex-col lg:justify-between lg:items-center">
          <div className="flex flex-col gap-y-5 lg:w-[100%] w-full">
            <div className="">
              <div className="text-shuttlelaneBlack">
                <h1 className="text-3xl lg:text-6xl text-center font-bold mt-3 leading-[39px]">
                  Track Booking
                </h1>
                <div className="flex flex-col text-center gap-y-3 leading-[22px] mt-3">
                  <p className="text-lg font-normal">
                    Stay in Control: Track, Modify, and Plan Your Airport and
                    Travel Arrangements with Ease.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* More About Shuttlelane */}
      <div className="p-7 lg:px-24 py-10" ref={moreAboutUsRef}>
        {/* <Fade direction="up" duration={500}> */}
        <div className="w-full flex flex-row justify-center">
          <div className="h-14 w-full lg:w-[35%] border-gray-300 border-[.5px] rounded-full p-4 flex flex-row items-center">
            <input
              type="text"
              placeholder="Booking reference"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              className="w-[85%] bg-transparent border-none focus:border-none focus:outline-none"
            />

            <div className="w-[15%]">
              <button
                onClick={() => getBookingByBookingReference(searchValue)}
                className="h-7 w-7 rounded-full text-gray-300 hover:text-white hover:bg-slate-300 p-1 flex items-center justify-center"
              >
                <MdOutlineSearch size={21} className="" />
              </button>
            </div>
          </div>
        </div>

        {isLoading && (
          <div className="flex items-center justify-center w-full h-96">
            <div className="h-44 w-44 rounded-full bg-slate-400 animate-ping flex items-center justify-center delay-700">
              <div className="h-20 w-20 rounded-full bg-slate-300 animate-ping flex items-center justify-center delay-500">
                <div className="h-14 w-14 rounded-full bg-slate-200 animate-ping flex items-center justify-center delay-300">
                  <div className="h-8 w-8 rounded-full bg-slate-100 animate-ping flex items-center justify-center delay-0"></div>
                </div>
              </div>
            </div>
          </div>
        )}

        {!isLoading && bookingFetchedByReference && (
          <BookingDetails
            currentBooking={bookingFetchedByReference}
            bookingFetchedByReference={bookingFetchedByReference}
            isLoading={bookingFetchedByReference ? false : true}
          />
        )}

        {!bookingFetchedByReference && (
          <div className="w-full flex flex-col items-center justify-center">
            <img
              src={emptyImage}
              className="max-w-lg object-contain"
              alt="Sorry, there are no blog posts for now."
            />
            <p className="text-sm text-center">
              Try searching for a booking using a valid booking reference...
            </p>
          </div>
        )}

        {/* </Fade> */}
      </div>

      {/* How To Reach Us */}
      <HowToReachUs />
      <PaymentPartners />
      <Footer />
    </div>
  );
}

export default TrackBookingPage;
